<template>
	<!--<div :class="{focus: isInFocus }">-->
	<div>
		<div class="input-wrapper"
			  @input="onInput"
			  @keyup="onListKeyUp"
			  ref="inputSlot">

			<input class="_sidinnehall_filter" ref="input"
						type="text"
						v-bind="$props"
						:value="vpValue"
						placeholder="Sök text och/eller belopp" 
						name="text"
						autocomplete="off">

			<svg version="1.1" x="0px" y="0px" xml:space="preserve" viewBox="0 0 200 200"
					style="overflow:visible; enable-background:new new 0 0 200 200; stroke-linecap:round; stroke-linejoin:round; stroke-miterlimit:10;
			fill:none; stroke:rgb(152, 151, 148); stroke-width:13;
			height:1.15em; width:1.15em; top:0.42em; left:.35em; position:absolute; pointer-events: none;">
				<g id="Forstoringsglas">
					<line id="Skaft-smalt" x1="95.76" y1="112.86" x2="136.15" y2="180.05"></line>
					<polyline id="Skaft-tjockt" points="97.98,111.52 138.37,178.71 133.78,181.47 93.4,114.28 	"></polyline>
					<circle id="Glas" cx="70" cy="70" r="50"></circle>
				</g>
			</svg>
		</div>
	</div>
</template>

<script>

	'use strict';

	// Anv inte f.n:
	//import { isTouchDevice } from 'isTouchDevice';


	//#######################################################################################################

	export default {
		name: 'searchtext',
		data() {
			return {
				//text: '', //this.value,

				// Anv inte f.n:
				//isTouchDevice: isTouchDevice()
			};
		},
		props: {
			vpAccessKey: {
				type: String,
				default: null
			},
			vpValue: {
				type: String,
				default: ''
			},
		},
		methods: {
			onListKeyUp(e) {
				//console.log('onListKeyUp');
			},
			onInput(inputEvent) {
				//console.log('onInput');
			},
		},
		created() {
		},

		mounted() {
			// Note that mounted does not guarantee that all child components have also been mounted.

			// AccessKey-hanteringen måste ligga på app-nivån istället, för att kunna hantera att ev dold meny ska öppnas!

		}
	}
</script>
